import { createStore } from 'vuex'
import axios from 'axios'
import extract from './modules/extract'

export default createStore({
  state: {
    apiKey: localStorage.getItem('apiKey') || '',
    isAuthenticated: !!localStorage.getItem('apiKey'),
    outboxEntries: [],
    loading: false,
    error: null
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    apiKey: state => state.apiKey,
    outboxEntries: state => state.outboxEntries,
    loading: state => state.loading,
    error: state => state.error
  },
  mutations: {
    SET_API_KEY(state, apiKey) {
      state.apiKey = apiKey
      localStorage.setItem('apiKey', apiKey)
      state.isAuthenticated = !!apiKey
    },
    CLEAR_API_KEY(state) {
      state.apiKey = ''
      localStorage.removeItem('apiKey')
      state.isAuthenticated = false
    },
    SET_OUTBOX_ENTRIES(state, entries) {
      state.outboxEntries = entries
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    login({ commit }, apiKey) {
      commit('SET_API_KEY', apiKey)
    },
    logout({ commit }) {
      commit('CLEAR_API_KEY')
    },
    async fetchOutboxEntries({ commit, state }) {
      if (!state.isAuthenticated) return
      
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      try {
        const response = await axios.get('/api/outbox', {
          headers: {
            'X-API-Key': state.apiKey
          }
        })
        commit('SET_OUTBOX_ENTRIES', response.data)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.detail || 'Failed to fetch outbox entries')
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async extractAttributes({ commit, state }, requests) {
      if (!state.isAuthenticated) return
      
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      try {
        const response = await axios.post('/api/extract-attribute/async', requests, {
          headers: {
            'X-API-Key': state.apiKey,
            'Content-Type': 'application/json'
          }
        })
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.detail || 'Failed to extract attributes')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async uploadFiles({ commit, state }, formData) {
      if (!state.isAuthenticated) return
      
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      try {
        const response = await axios.post('/api/extract-attribute/files', formData, {
          headers: {
            'X-API-Key': state.apiKey,
            'Content-Type': 'multipart/form-data'
          }
        })
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.detail || 'Failed to upload files')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  modules: {
    extract
  }
}) 